import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import {connect} from 'react-redux';


import ClientTimestamp from 'app/components/common/client-timestamp';
import Icon            from 'app/components/common/icon';
import Popper          from 'app/components/common/popper';
import EmpImage        from 'app/components/company-admin/common/emp-image';
import Comment         from 'app/components/company-admin/grant-system/comment';
import NewComment      from 'app/components/company-admin/grant-system/comments-new';
import GrantSysDuck    from 'app/ducks/company-admin/grant-system';
import EntitiesSlx     from 'app/selectors/entities';



const empName = (employee) => {
  if (!employee) return 'Someone';
  const name = [employee.firstName, employee.lastName].filter(Boolean).join(' ');
  return name || employee.email || 'Someone';
};

class CommentsPopover extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      addMd: '',
      showAdd: false,
      isOpen: false,
    };

    this.refCommentsCon = React.createRef();

    this.renderCommentPopover = this.renderCommentPopover.bind(this);
    this.onClickAddBtn = this.onClickAddBtn.bind(this);
    this.onCancelAdd = this.onCancelAdd.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onCreated = this.onCreated.bind(this);
  }

  get showAdd() {
    if (this.state.showAdd) return true;
    if (!this.props.comments?.length) return true;
    return false;
  }

  onOpen() {
    this.setState({isOpen: true});
  }
  onClose() {
    this.setState({showAdd: false, isOpen: false});
  }

  onClickAddBtn() {
    this.setShowAdd(true);
  }

  onCancelAdd() {
    this.setShowAdd(false);
  }

  onCreated() {
    this.setShowAdd(false);
    this.scrollToLast();
  }

  setShowAdd(showAdd) {
    // timeout used or else the onDocumentClick logic in Popper will break
    setTimeout(() => {
      this.setState({showAdd}, () => {
        Popper.updateAll();
      });
    }, 0);
  }

  scrollToLast() {
    const el = this.refCommentsCon.current;
    if (!el) return;
    setTimeout(() => {
      el.scrollTop = el.scrollHeight;
    }, 100);
  }

  renderCommentPopover() {
    const {comments, appId, assId, answer} = this.props;
    const count = comments?.length || 0;
    return (
      <>
        <div className="gacom-cpop-coms" ref={this.refCommentsCon}>
          {!count && (
            <p className="_italic _clr-mid">No comments here yet.</p>
          )}
          {(comments || []).map((comment) => {
            return (
              <div className="gacom-cpop-com" key={comment.id}>
                <div className="gacom-cpop-com-top">
                  <EmpImage className="gacom-cpop-com-top-img" employee={comment.employee} />
                  <div className="gacom-cpop-com-top-name">{empName(comment.employee)}</div>
                  <ClientTimestamp.DateTimeTz timestamp={comment.createdTs} className="gacom-cpop-com-top-ts" />
                </div>
                <Comment comment={comment} appId={appId} />
              </div>
            );
          })}
        </div>
        <div className="gacom-cpop-add">
          {this.showAdd ? (<>
            <NewComment appId={appId} assId={assId} answerId={answer.id} focusOnMount onCancel={count ? this.onCancelAdd : undefined} className="gacom-cpop-add-form" onCreated={this.onCreated} />
          </>) : (<>
            <div className="gacom-cpop-add-fake" tabIndex={-1} onClick={this.onClickAddBtn}>Type a comment...</div>
          </>)}
        </div>
      </>
    );
  }

  render() {
    const {answer, comments} = this.props;
    const fillClass = comments?.length ? 'filled' : 'empty';
    const openClass = this.state.isOpen ? 'open' : 'closed';
    const btnText = comments?.length ? comments.length : 'Comment';
    return (
      <Popper
        popContent={this.renderCommentPopover}
        tagType="button"
        clickTrigger
        popType="popover"
        placement="right"
        clickOutsideUntrigger
        popClassName="gacom-cpop"
        className={`gacom-cpop-target ${fillClass} ${openClass}`}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <Icon.MessageBubbleEmpty /> {btnText}
      </Popper>
    );
  }

}

CommentsPopover.propTypes = {
  appId: PropTypes.string.isRequired,
  answer: PropTypes.object.isRequired,
  assId: PropTypes.string,
};
CommentsPopover.defaultProps = {};

const stateToProps = (state, ownProps) => {
  const app = EntitiesSlx.plainGrantAppById(state, ownProps.appId);
  return {
    comments: GrantSysDuck.Slx.appCommentMap(state, app)[ownProps.answer?.id],
  };
};
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CommentsPopover);
